import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from '@mui/material';
import React, { useState } from 'react';

import CustomButton from '../../designSystem/Button';
import { handleExportGenericPDF } from './banks/0';
import { handleExportBancoDeChileXLSX } from './banks/1';
import { handleExportBICECsv } from './banks/28';
import { handleExportSantanderXLSX } from './banks/37';
import { handleExportItauTxt } from './banks/39';
import { handleExportConsorcioXLSX } from './banks/55';
import { ExportBankFunction, Payment } from './types';

const availableBanks: Record<
  number,
  { name: string; export: ExportBankFunction }
> = {
  0: { name: 'PDF Genérico', export: handleExportGenericPDF },
  1: { name: 'Banco de Chile', export: handleExportBancoDeChileXLSX },
  28: { name: 'Banco BICE', export: handleExportBICECsv },
  37: { name: 'Banco Santander', export: handleExportSantanderXLSX },
  39: { name: 'Banco Itaú', export: handleExportItauTxt },
  55: { name: 'Banco Consorcio', export: handleExportConsorcioXLSX },
};

type NomineeExporterProps = {
  payments: Payment[];
  open: boolean;
  setOpen: (open: boolean) => void;
  id: string;
};

const NomineeExporter = (props: NomineeExporterProps) => {
  const { payments, open, setOpen, id } = props;
  console.log('payments', payments);
  const [message, setMessage] = useState(`Operación ${id}`);
  const [bankCode, setBankCode] = useState(0);
  if (open === false) return null;

  const handleExport = (m: string) => {
    const bank = availableBanks[bankCode];
    if (!bank) return;
    void bank.export(payments, id, m);
  };

  const handleClose = () => {
    if (setOpen) setOpen(false);
  };
  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle>Exportar</DialogTitle>
        <DialogContent>
          <Typography variant="body1" gutterBottom>
            Estos son los bancos disponibles para exportar nóminas.
          </Typography>
          <FormControl
            variant="outlined"
            fullWidth
            style={{ marginBottom: '10px' }}
          >
            <InputLabel id="bank">Banco</InputLabel>
            <Select
              labelId="filter-label"
              id="Filtrar por estado"
              fullWidth
              value={bankCode}
              onChange={(e) => setBankCode(e.target.value as number)}
              label="Banco"
            >
              {Object.entries(availableBanks).map(([key, bank]) => (
                <MenuItem key={key} value={key}>
                  {bank.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <TextField
            label="Mensaje en glosa"
            variant="outlined"
            fullWidth
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            style={{ marginBottom: '10px' }}
          />
        </DialogContent>
        <DialogActions>
          <CustomButton color="secondary" onClick={handleClose}>
            Cancelar
          </CustomButton>
          <CustomButton
            onClick={() => handleExport(message)}
            variant="contained"
            color="primary"
            size="small"
          >
            Exportar
          </CustomButton>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default NomineeExporter;
